<template>
  <div class="home">
    <div class="home_wrapper">
      <F-Header/>
      <!-- 内容 -->
      <div class="cont_box">
        <div class="home_wrapper">
          <div class="cont" v-for="item in options.govs">
            <h2><a>{{ item.name }}</a></h2>
            <div class="unit_list">
              <ul>
                <li v-for="item in item.regions" @click="getPath(item.id)" class="link">
                  {{ item.simpleName }}
                </li>
                <div class="clearfix"/>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <F-Footer/>
    </div>
	<div class="dialog" v-if="show.dialog">
	    <div class="dialog-head">公告</div>
	    <div class="dialog-body">
			<p>2016-2020公示数据请前往旧版本查阅。</p>
	    </div>
	    <div class="dialog-foot">
	        <button @click="toNewVersion" class="dialog-button">前往旧版</button>
	        &nbsp;&nbsp;&nbsp;&nbsp;
	        <button @click="closeDialog" class="dialog-button">关闭</button>
	    </div>
	</div>
  </div>
</template>
<script>
// @ is an alias to /src
import {CustomOpenApis as api} from "@/api/CustomApis";
import FHeader from "@/views/portal/F-Header";
import FFooter from "@/views/portal/F-Footer";

export default {
  name: 'Home',
  components: {FHeader, FFooter},
  data() {
    return {
      options: {
        govs: []
      },
      show: {
        dialog: true
      }
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    initData() {
      this.$http.get(api.getGovList).then(result => {
        if (result.status !== 200) {
          this.$message.error(result.message)
          return
        }
        this.options.govs = result.data
        this.options.govs.sort((a, b) => {
          return b.sort - a.sort
        })
      })
    },

    getPath(id) {
      let routeData = this.$router.resolve({
        path: '/info-list',
        query: {id: id}
      });
      window.open(routeData.href, '_blank');
    },
    toNewVersion() {
        console.log('toNewVersion()');
        window.open("http://58.42.212.233:8089/");
    },
    closeDialog() {
        this.show.dialog = false;
        console.log('closeDialog()');
    },
  }
}
</script>
<style scoped>
@import "~@public/reset.css";
@import "~@public/infoShow.css";

.link {
  color: #000
}
.dialog {
    width: 200px;
    height: 200px;
    background: #b5e2e6c7;
    position: fixed;
    top: 30vh;
    right: 0px;
    border-radius: 15px;
}

.dialog-head {
    flex-wrap: wrap;
    text-align: center;
    font-size: 20px;
}

.dialog-body {
    display: flex;
    flex-wrap: wrap;
    height: 55%;
    width: 100%;
    text-align: center;
    /*实现垂直居中*/
    align-items: center;
    /*实现水平居中*/
    justify-content: center;
    font-size: 18px;
    color: #c6121d;
    padding: 0px 5px;
}
.dialog-body p{
	text-indent: 2em;
}

.dialog-foot {
    /*实现垂直居中*/
    align-items: center;
    /*实现水平居中*/
    justify-content: center;
    display: flex;
    flex-wrap: wrap;
    height: 30%;
    width: 100%;
    text-align: right;
}

.dialog-button {
	width: 72px;
    height: 30px;
}
</style>
